// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wN-z","twoColumnImage":"xN-z"};